import { flow } from 'fp-ts/lib/function';
import { Lens } from 'monocle-ts';
import { iso } from 'newtype-ts';
import { match } from 'ts-pattern';
import * as Mmt from '../measurement';
// provides ability to wrap, unwrap, and modify the newtype
const _ = iso();
// export functions from here
export const create = _.wrap;
export const createRectangleMeters = (width, depth) => create({ _tag: 'Rectangle', width: Mmt.createMeters(width), depth: Mmt.createMeters(depth) });
export const updateRectangle = (width, depth) => _.modify(fd => match(fd._tag)
    .with('Rectangle', () => ({ ...fd, width, depth }))
    .exhaustive());
const widthL = _.composeLens(Lens.fromProp()('width'));
const depthL = _.composeLens(Lens.fromProp()('depth'));
export const widthMeters = flow(widthL.get, Mmt.meters);
export const depthMeters = flow(depthL.get, Mmt.meters);
/** Express the FloorDimensions vertices in a 2-dimensional coordinate space. Counter-clockwise, with the top-left corner at the origin */
export const verticesMeters = (fd) => {
    const width = widthMeters(fd);
    const depth = depthMeters(fd);
    return [
        { x: 0, y: 0 },
        { x: 0, y: depth },
        { x: width, y: depth },
        { x: width, y: 0 },
    ];
};
